import classNames from "classnames";
import styles from "./styles.module.scss";

type Props = {
  icon?: React.SVGProps<SVGSVGElement>;
  title: string;
  count: number;
};

const ClientsStats = ({ icon, title, count = 0 }: Props): JSX.Element => (
  <div className={styles.state}>
    <>
      {icon}
      <div className={styles.column}>
        <p className={classNames(styles.p3, styles.g400)}>{title}</p>
        <p className={styles.statsCount}>{count?.toLocaleString()}</p>
      </div>
    </>
  </div>
);

export default ClientsStats;
